export const transition = { 
    duration: .25, 
    ease: [.56, .03, .12, 1.04],
};

export const variants = { 
    initial: { 
        opacity: 0,
    }, 
    animate: { 
        opacity: 1,
    },
    grabInitial: {
        x: '25%',
        opacity: 0,
    },
    grabAnimate: {
        x: 0,
        opacity: 1,
    }
};